import { useMemo } from 'react';
import { NavigationMois } from '../CalendrierGrille';
import { moisSansAnnee } from './dates';
import { aussiChoisis, joursVisibles } from './selection';
import type { Nd } from './useNouvelleDemande';

/**
 * Le sélecteur de mois (‹ OCTOBRE 2026 › Aujourd'hui) : TOUJOURS juste au-dessus des jours du calendrier, jamais ailleurs dans la page (règle de l'utilisateur,
 * 21/10 ; c'est aussi celle des calendriers du Tableau de bord, qui partagent ce même composant : « même interaction dans toutes les vues Calendrier »). Il fait
 * donc partie du calendrier : GrilleSelection le rend en premier, directement avant la grille, si bien que rien (message, alerte, légende, aide) ne peut
 * s'intercaler entre lui et les jours. À sa droite, « Aussi choisis (gardés) » dit les jours choisis qui sont sur un autre mois ; quand la place manque, cette
 * phrase passe AU-DESSUS (flex-wrap: wrap-reverse), jamais en dessous.
 */
export function BarreMois({ nd }: { nd: Nd }) {
  const { etat, dispatch, aujourdhui } = nd;
  const hors = useMemo(() => aussiChoisis(etat.jours, joursVisibles(etat.mois)), [etat.jours, etat.mois]);
  const [annee, mois] = etat.mois.split('-').map(Number);
  return (
    <div className="nd-barre">
      <NavigationMois
        mois={new Date(annee, mois - 1, 1)} idMois="nd-mois"
        onChange={(m) => dispatch({ type: 'mois', mois: `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, '0')}-01` })}
      />
      {hors.length > 0 && (
        <p className="nd-garde">
          Aussi choisis (gardés) :{' '}
          {hors.map(([m, n], i) => (
            <span key={m}>
              {i > 0 && ', '}
              <button
                type="button" className="nd-lien nd-lien--ligne" aria-label={`${n}${i === 0 ? ` jour${n > 1 ? 's' : ''}` : ''} en ${moisSansAnnee(`${m}-01`, aujourdhui)} : afficher ce mois`}
                onClick={() => { const premier = etat.jours.find((d) => d.startsWith(m)); dispatch({ type: 'mois', mois: `${m}-01`, focus: premier }); nd.apresRendu(() => document.querySelector<HTMLElement>('.nd-jour[tabindex="0"]')?.focus()); }}
              >
                {n}{i === 0 ? ` jour${n > 1 ? 's' : ''}` : ''} en {moisSansAnnee(`${m}-01`, aujourdhui)}
              </button>
            </span>
          ))}.
        </p>
      )}
    </div>
  );
}
